import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

export default function ScrollToggleButton() {
  const [isVisible, setIsVisible] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const router = useRouter();
  const VOTE_URL = '/promotions/2025-pick-and-choo/vote?tab=content';

  const handleClick = () => {
    router.push(VOTE_URL);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY < lastScrollY) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  return (
    <div
      className={`block pc:hidden fixed p-4 bottom-[env(safe-area-inset-bottom,5px)] transition-opacity duration-300 h-[80px] w-full bg-white z-50 ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}>
      <button
        className="!w-full flex px-6 py-4 text-white text-xs font-bold justify-center items-center rounded-[8px] bg-primary-500 "
        onClick={handleClick}>
        투표하러 가기
      </button>
    </div>
  );
}
